import { PropsWithChildren } from "react";

export function Card({ children }: PropsWithChildren) {
  return (
    <div
      className={"p-4 w-full bg-white rounded-lg shadow-md shadow-slate-200"}
    >
      {children ?? null}
    </div>
  );
}
